import { updateShoninCommentHojoSeqList } from "@/api/shinsei.api";
import { CheckMsg, ComfirmMsg, InfoMsg } from "@/constants/message.constant";
import { ShoninCommentHojoModel } from "@/interfaces/shinsei.interface";
import { ElMessageBox } from "element-plus";
import { h, Ref } from "vue";
import { shoninCommentHojoInfo } from "./config";

export function useChangeSeqList(
  isEditSeqMode: Ref<boolean>,
  getList: () => void,
  list: shoninCommentHojoInfo[]
) {
  const handleResetAllSeq = () => {
    list.forEach((row) => {
      row.seq = row.oldSeq;
      row.hasSeqEdited = false;
      row.hasSeqExisted = false;
    });
    isEditSeqMode.value = false;
  };

  const handleRowSeqChanged = (row: shoninCommentHojoInfo) => {
    //半角数値以外の場合、エラー
    if (typeof row.seq === "string" && /\D/.test(row.seq)) {
      ElMessageBox({
        title: "エラー",
        type: "error",
        message: CheckMsg.CHK_ISNUM,
      });
      row.hasSeqExisted = true;
      return;
    }
    row.hasSeqEdited = row.seq !== row.oldSeq;
  };

  const checkExistedSeq = () => {
    const repeatedSeq = list
      .map((item) => item.seq)
      .filter(
        (item, index, arr) =>
          arr.indexOf(item) !== arr.lastIndexOf(item) &&
          arr.indexOf(item) === index
      );
    if (repeatedSeq.length === 0) {
      return true;
    }

    const errorMsgs = repeatedSeq
      .map((item) => h("p", { style: "color: #b87d11" }, "SEQ：" + item))
      .concat([h("span", null, InfoMsg.INfO_REPEATED_SEQ)]);

    ElMessageBox({
      title: "エラー",
      type: "error",
      message: h("p", null, errorMsgs),
    });
    list.forEach((item) => {
      item.hasSeqExisted = false;
      if (repeatedSeq.includes(item.seq)) {
        item.hasSeqExisted = true;
      }
    });
    return false;
  };
  const handleUpdateSeq = async () => {
    ElMessageBox({
      title: "確認",
      message: ComfirmMsg.CFM_EDIT,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "はい",
      cancelButtonText: "いいえ",
    })
      .then(async () => {
        if (!checkExistedSeq()) {
          return;
        }
        const needUpdateSeq: Pick<ShoninCommentHojoModel, "id" | "seq">[] = [];
        list.forEach((row) => {
          if (row.hasSeqEdited) {
            needUpdateSeq.push({
              id: row.id,
              seq: row.seq,
            });
          }
        });
        await updateShoninCommentHojoSeqList(needUpdateSeq);
        isEditSeqMode.value = false;
        getList();
      })
      .catch((cancel) => {
        console.log(cancel);
      });
  };

  return {
    handleResetAllSeq,
    handleRowSeqChanged,
    handleUpdateSeq,
  };
}
